{
  "de": {
    "login": {
      "acceptTos": "Allgemeinen Geschäftsbedingungen",
      "acceptTosPrefix": "Ich akzeptiere die ",
      "acceptTosRequired": "Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren, um ein Konto zu erstellen.",
      "auth-ziggu/invalid-invitation-code": "Bitte fragen Sie die Person, die Ihnen den Link geschickt hat, ob ein neuer Link verfügbar ist. Falls Sie bereits ein Konto haben, melden Sie sich stattdessen an.",
      "auth-ziggu/user-created": "Ihr Benutzerkonto wurde erstellt! 🎉 Wir melden Sie jetzt an, einen Moment..",
      "auth/invalid-action-code": "Aus Sicherheitsgründen laufen Links zum Zurücksetzen des Passworts nach kurzer Zeit ab. Wenn Sie Ihr Passwort weiterhin zurücksetzen möchten, können Sie eine neue E-Mail zum Zurücksetzen anfordern.",
      "auth/invalid-credential": "Das Passwort ist für diese E-Mail-Adresse ungültig, oder es existiert kein Konto für diese E-Mail-Adresse.",
      "auth/invalid-email": "Die E-Mail-Adresse ist ungültig.",
      "auth/network-request-failed": "Ein Netzwerkfehler ist aufgetreten. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "auth/too-many-requests": "Zu viele Anfragen. Bitte versuchen Sie es später erneut.",
      "backToLogin": "Zurück zur Anmeldung",
      "cookiePolicy": "Cookie-Richtlinie",
      "emailAddress": "E-Mail-Adresse",
      "emailAddressInvalid": "Geben Sie eine gültige E-Mail-Adresse ein",
      "emailAddressRequired": "E-Mail-Adresse ist erforderlich",
      "googleLogin": "Mit Google anmelden",
      "notification_error_no_access": "Ihr Konto hat keinen Zugriff.",
      "notification_error_session_expired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
      "notification_success_logout": "Sie haben sich von Ihrem Konto abgemeldet.",
      "password": "Passwort",
      "passwordConfirmMatchRequired": "Die Passwortbestätigung stimmt nicht überein",
      "passwordConfirmRequired": "Passwortbestätigung ist erforderlich",
      "passwordForgot": "Passwort vergessen?",
      "passwordLengthRequired": "Das Passwort muss mindestens 8 Zeichen enthalten",
      "passwordRequired": "Passwort ist erforderlich",
      "password_confirm": "Passwortbestätigung",
      "privacyPolicy": "Datenschutzerklärung",
      "submit_expired_reset": "Neuen Passwort-Reset anfordern",
      "submit_expired_signup": "Zurück zur Anmeldung",
      "submit_login": "Anmelden",
      "submit_password_forgot": "Passwort-Reset anfordern",
      "submit_password_reset": "Passwort zurücksetzen",
      "submit_signup": "Konto erstellen",
      "success_password_forgot": "Falls Sie ein aktives Konto haben, wurde eine E-Mail zum Zurücksetzen des Passworts an {email} gesendet. Bitte überprüfen Sie Ihren E-Mail-Posteingang, der Link zum Zurücksetzen des Passworts läuft in 1 Stunde ab.",
      "success_password_reset": "Passwort erfolgreich zurückgesetzt, Sie werden jetzt angemeldet...",
      "termsandconditionsPolicy": "Allgemeine Geschäftsbedingungen",
      "title_expired_reset": "Hoppla, dieser Link ist abgelaufen..",
      "title_expired_signup": "Dieser Einladungslink ist nicht mehr aktiv",
      "title_login": "Willkommen zurück!",
      "title_password_forgot": "Passwort vergessen?",
      "title_password_reset": "Passwort zurücksetzen",
      "title_signup": "Registrierung abschließen"
    }
  }
}
